// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyQuestionCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.402 18v-.006l2.035.006h.003a3.563 3.563 0 0 0 1.728-6.678l-.968-.54a.2.2 0 0 1-.102-.183l.046-1.108c.002-.036.002-.073.002-.11a2.573 2.573 0 0 0-3.692-2.32l-1.08.524a.2.2 0 0 1-.219-.03l-.898-.796a5.347 5.347 0 0 0-8.865 3.506l-.078.852a.2.2 0 0 1-.088.148l-.71.477A3.418 3.418 0 0 0 5.4 18h.008zm2 2H5.39a5.418 5.418 0 0 1-2.99-9.918 7.347 7.347 0 0 1 12.182-4.82 4.573 4.573 0 0 1 6.56 4.313A5.563 5.563 0 0 1 18.472 20h-.036zm-3.744-9c0 .855-.527 1.316-1.04 1.764-.407.356-.806.705-.925 1.238-.04.18-.184.331-.369.331h-.666c-.184 0-.336-.15-.316-.333.104-.974.664-1.403 1.163-1.785.433-.332.82-.629.82-1.215 0-.733-.6-1.333-1.334-1.333-.62 0-1.144.428-1.292 1.003-.045.179-.19.33-.375.33h-.666c-.184 0-.336-.15-.313-.333a2.666 2.666 0 0 1 5.313.333zm-3.333 4.334c0-.185.149-.334.333-.334h.667c.184 0 .333.15.333.334V16c0 .184-.15.333-.333.333h-.667a.333.333 0 0 1-.333-.333z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyQuestionCloud;
